var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"skeleton"},[_c('div',{staticClass:"skeleton__item",style:('background-color:' + _vm.color + ';' + 'height:' + _vm.height + ';' + 'width:' + _vm.width + ';' + _vm.styleInject),attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }